/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';

import { getStudyPlanAxios } from '@/store/study-plan/actions';

import { selectStudyPlan } from '@/store/study-plan/selectors';

import { Card } from '../card';

import { classNames } from '@shared/utils/styles-utils';

import _get from 'lodash/get';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const cn = classNames(styles);

export const Plan = ({ isAnother, showCalendarModal, planParams = {}, userId, currentUser }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('plan');

  const params = {
    userId,
    size: 15,
    sort: 'id,desc&sort=startDate,desc',
    page: 0,
    ...planParams,
  };

  const loadMore = page =>
    dispatch(
      getStudyPlanAxios({
        ...params,
        isPersonalized: true,
        page: page - 1,
      })
    );

  useEffect(() => {
    dispatch(
      getStudyPlanAxios({
        ...params,
        isPersonalized: true,
      })
    );
  }, []);

  const { studyPlanNew, studyPlanNewPagination, studyPlanNewLoading } = useSelector(selectStudyPlan);

  const showList = !!(studyPlanNew && studyPlanNew.length);

  const hasMore =
    !studyPlanNewLoading &&
    studyPlanNewPagination?.total > (studyPlanNewPagination?.currentPage + 1) * studyPlanNewPagination?.pageSize;

  return (
    <div className={cn('plan')}>
      {showList ? (
        <div className={cn('plan__body')}>
          <InfiniteScroll
            initialLoad={false}
            loadMore={loadMore}
            hasMore={hasMore}
            pageStart={1}
            threshold={10}
            className={cn('plan__list')}
          >
            {studyPlanNew.map(material => (
              <Card
                key={material.id}
                material={material}
                isAnother={isAnother}
                showCalendarModal={showCalendarModal}
                currentUser={currentUser}
              />
            ))}
          </InfiniteScroll>
        </div>
      ) : (
        !studyPlanNewLoading && (
          <div className={cn('plan__body_empty')}>
            {t('completeMaterials')} <br /> {t('feedback')}
          </div>
        )
      )}
    </div>
  );
};

Plan.propTypes = {
  isAnother: PropTypes.bool,
  showCalendarModal: PropTypes.any,
  planParams: PropTypes.object,
  userId: PropTypes.number,
  currentUser: PropTypes.object,
};
